import { Reveal } from "@/components/Reveal";

const ProjectCard = ({ project, index = 0 }) => (
  <Reveal delay={index * 0.12}>
    <div
      className="group border border-ink/10 bg-bone"
      data-testid={`project-card-${project.slug}`}
    >
      <div className="relative overflow-hidden border-b border-ink/10 bg-white">
        <span className="absolute top-3 left-3 w-4 h-4 border-t border-l border-ink/50 z-10 pointer-events-none" aria-hidden="true" />
        <span className="absolute top-3 right-3 w-4 h-4 border-t border-r border-ink/50 z-10 pointer-events-none" aria-hidden="true" />
        <span className="absolute bottom-3 left-3 w-4 h-4 border-b border-l border-ink/50 z-10 pointer-events-none" aria-hidden="true" />
        <span className="absolute bottom-3 right-3 w-4 h-4 border-b border-r border-ink/50 z-10 pointer-events-none" aria-hidden="true" />
        <img
          src={project.surveyPlan}
          alt={project.altText}
          className="w-full aspect-[4/3] object-contain p-3 transition-transform duration-700 ease-out group-hover:scale-105"
          loading="lazy"
        />
        <p className="border-t border-ink/10 bg-bone px-4 py-2.5 text-[10px] uppercase tracking-[0.15em] text-graphite text-center">
          For general information purposes only
        </p>
      </div>
      <div className="p-8 md:p-10">
        <h3 className="text-2xl md:text-3xl tracking-tight font-semibold uppercase">{project.name}</h3>
        {project.description && (
          <p className="text-sm text-graphite leading-relaxed mt-4">{project.description}</p>
        )}
      </div>
    </div>
  </Reveal>
);

export default ProjectCard;
